/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import wretch from "wretch";
import "../../app/assets/stylesheets/app.scss";
import { REDUCERS } from "../isomorphic/components/helper/reducers";
import { preRenderApplication, renderApplication } from "./render";

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

const CUSTOM_REDUCERS = REDUCERS;
// asda

global.wretch = wretch;

startApp(renderApplication, CUSTOM_REDUCERS, {
  enableServiceWorker: process.env.NODE_ENV === "production",
  appVersion: require("../isomorphic/app-version"),
  preRenderApplication
}).then(enableHotReload);
